var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumber1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#151514;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#CF0810;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "722.3,131.5 707.3,463 704.1,535.1 689,868.5 440.4,852.6 438.7,535.1 438.5,508.7 438.4,483.1  438.3,458.9 438.1,431 388,473.3 277.7,331.5 460.5,158  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M679.2,509.1l-15,331.8l-198-12.7l-1.7-319.1H508c8.7,26.1,33.2,44.9,62.2,44.9c29,0,53.6-18.8,62.2-44.9 H679.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M695,160.4l-13.5,298h-53c-10.9-21.1-32.9-35.5-58.3-35.5c-25.4,0-47.4,14.4-58.2,35.5h-47.7l-0.4-83 L391.9,436l-79.2-101.8L471.9,183L695,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M615.3,488.4c0,24.9-20.2,45.1-45.1,45.1c-24.9,0-45.1-20.2-45.1-45.1c0-24.9,20.2-45.1,45.1-45.1 C595.1,443.3,615.3,463.5,615.3,488.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber1);
export default __webpack_public_path__ + "static/media/number1.c85590f5b28bb789705cc4e9e9de348e.svg";
export { ForwardRef as ReactComponent };